import React, { Component } from "react";
import ReportHeader from "../Reports/Common/ReportHeader";
import ReportBody from "../Reports/Common/ReportBody";
import Input from "../2/Controls/Input";
import ReportButton from "../Reports/Common/ReportButton";
import Spinner from "../Common/Spinner";
import Pagination from "react-js-pagination";
import axios from "axios";
import * as constants from "../../Constatnts";

class WHReturn extends Component {
  constructor() {
    super();
    this.state = {
      selectedStoreID: "",
      approvalStatus: "Pending",
      records: [],
      selectedRecord: null,
      modalVisible: false,
      smartStoreList: [],
      activePage: 1,
      size: 50,
      totalItemsCount: 0,
      paginationStatus: "",
      loading: false,
    };
  }

  async componentDidMount() {
    await this.populateSmartStores();
    this.loadData(1);
  }

  async populateSmartStores() {
    let smartStores = this.props.config.SmartStores;

    if (smartStores.length === 0) {
      let registrations = await this.props.getPincodeSmartRegistrations();
      let tmp = await this.props.getPincodeStores(registrations);

      if (tmp && tmp.searchResult && tmp.searchResult.length > 0) {
        tmp.searchResult.map((s) => {
          if (s.PincodeServiceProviderID && s.PincodeServiceProviderID.trim() !== "") {
            smartStores.push(s);
          }
        });
      }

      this.props.setSmartStores(smartStores);
    }

    this.setState({ smartStoreList: smartStores });
  }

  async loadData(page, exportData) {
    this.setState({ loading: true });

    const params = {
      page: page,
      limit: this.state.size,
      storeId: this.state.selectedStoreID || null,
      status: this.state.approvalStatus || null,
    };

    const BaseURL = "https://backend-197598313260.asia-south1.run.app";
       //const BaseURL = "http://localhost:4000";
    const response = await axios.get(BaseURL + "/v1/vendorstockinward/whreturn", { params });

    if (exportData === true) {
      const csv = constants.objToCSV(response.data.data);
      const blob = new Blob([csv], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "WHReturn_Report.csv";
      a.click();
      return;
    }

    const total = response.data.total;

    this.setState({
      records: response.data.data,
      totalItemsCount: total,
      activePage: page,
      loading: false,
    });

    this.updatePaginationMessage(total, (page - 1) * this.state.size);
  }

  async viewRecord(record) {
  
     this.props.history.push({
                    pathname: `/home/pincode/WHReturnItemsView/${record.StoreID}`,
                  });
    // this.setState({ loading: true });

    // const BaseURL = "https://backend-197598313260.asia-south1.run.app";
    // const URL = BaseURL + "/v1/whreturn/" + record._id;
    // const response = await axios.get(URL);

    // this.setState({
    //   selectedRecord: response.data.data,
    //   modalVisible: true,
    //   loading: false,
    // });
  }

  handlePageChange = (page) => {
    this.loadData(page);
  };

  updatePaginationMessage(totalItems, startIndex) {
    let msg = "";

    if (totalItems === 0) {
      msg = "No records to display";
    } else if (startIndex + this.state.size >= totalItems) {
      msg = "Showing " + (startIndex + 1) + " to " + totalItems + " of " + totalItems;
    } else {
      msg = "Showing " + (startIndex + 1) + " to " + (startIndex + this.state.size) + " of " + totalItems;
    }

    this.setState({ paginationStatus: msg });
  }

  exportData() {
    this.loadData(this.state.activePage, true);
  }

  renderModal() {
    if (this.state.modalVisible !== true) {
      return null;
    }

    return (
      <div className="modal-backdrop">
        <div className="modal" style={{ padding: 20 }}>
          <h3>WH Return Details</h3>
          <pre>{JSON.stringify(this.state.selectedRecord, null, 2)}</pre>
          <button
            className="btn btn-danger"
            onClick={() => this.setState({ modalVisible: false })}
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  render() {
    function convertToMMDDYYYY(dateString) {
  const date = new Date(dateString);

  const month = date.getUTCMonth() + 1;  // 0-based hota hai
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();

  return `${month}/${day}/${year}`;
}
    return (
      <div className="content-wrapper">
        <section className="content">
          <ReportHeader
            title="WH Return"
            showBack={true}
            onBack={() => this.props.history.push({ pathname: "/home/" })}
          />

          <ReportBody>
            <div className="row">
              <div className="col-md-2">
                <Input
                  type="select"
                  label="Store"
                  value={this.state.selectedStoreID}
                  onChange={(value) => this.setState({ selectedStoreID: value })}
                >
                  <option value="">All</option>
                  {this.state.smartStoreList.map((s, idx) => (
                    <option key={idx} value={s.key}>
                      {s.StoreName}
                    </option>
                  ))}
                </Input>
              </div>

              <div className="col-md-2">
                <Input
                  type="select"
                  label="Status"
                  value={this.state.approvalStatus}
                  onChange={(value) => this.setState({ approvalStatus: value })}
                >
                  <option value="Pending">Pending</option>
                  <option value="Ready To Return">Ready To Return</option>
                  {/* <option value="Completed">Completed</option> */}
                </Input>
              </div>
            </div>

            <div className="row">
              <div className="col-md-8"></div>
              <div className="col-md-4">
                <ReportButton type="search" onClick={() => this.loadData(1)} />
                <ReportButton
                  type="clear"
                  onClick={() =>
                    this.setState(
                      {
                        selectedStoreID: "",
                        approvalStatus: "Pending",
                      },
                      () => this.loadData(1)
                    )
                  }
                />
                <ReportButton type="export" onClick={() => this.exportData()} />
              </div>
            </div>

            <br />

            <div className="row">
              <div className="col-md-12">
                {this.state.loading && <Spinner />}

                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Txn No</th>
                      <th>Date</th>
                       <th>Pickup Date</th>
                        <th>Total Qty</th>
                      <th>Store</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {this.state.records.map((rec) => {
                      return (
                        <tr key={rec._id}>
                          <td>{rec.ReturnTransactionNo}</td>
                          <td>{convertToMMDDYYYY(rec.ReturnTransactionDate)}</td>
                             <td>{convertToMMDDYYYY(rec.PickupDate)}</td>
                              <td>{rec.TotalQty}</td>
                          <td>{rec.StoreName}</td>
                          <td>{rec.Status}</td>
                          <td>
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() => this.viewRecord(rec)}
                            >
                              View
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            {this.state.totalItemsCount > 0 && (
              <div className="row">
                <div className="col-md-12">
                  <div style={{ marginTop: 15 }}>{this.state.paginationStatus}</div>

                  <Pagination
                    activePage={this.state.activePage}
                    itemsCountPerPage={this.state.size}
                    totalItemsCount={this.state.totalItemsCount}
                    pageRangeDisplayed={3}
                    onChange={this.handlePageChange}
                  />
                </div>
              </div>
            )}

            {this.renderModal()}
          </ReportBody>
        </section>
      </div>
    );
  }
}

export default WHReturn;